/**
 * The request header names of the platform API (multi-product 005 §2 step 1,
 * §3; 002 §9.3). The firm is the request's ONE claim: no header names the
 * scope (022 G48b) or the app (G30, API-2). Moved here from
 * `src/domain/organisation/requested-org.ts`, which re-exports it.
 */

/** The firm claim: the organisation id the caller wants to act in. */
export const ORG_HEADER = "x-cova-org"
